import { useCallback, useRef } from 'react'
import { toast } from 'react-toastify'
import { useSelector, useDispatch } from 'react-redux'

import {
  coreActions,
  coreSelectors,
} from '@gymcloud/core'

const mapState = (state: any) => {
  const profile = coreSelectors.getProfile(state)

  return {
    profile,
  }
}

export function useCompleteTutorial() {
  const dispatch = useDispatch()
  const inFlightRef = useRef<Record<string, boolean>>({})
  const { profile } = useSelector(mapState)
  const completedSteps = profile.user_settings.tutorial_steps

  const completeTutorialStep = useCallback(async (step: string, opts?: { silent?: boolean }) => {
    const already = completedSteps.includes(step)
    if (already) {
      return { already: true }
    }

    if (inFlightRef.current[step]) {
      return { inFlight: true }
    }
    inFlightRef.current[step] = true

    try {
      const result = dispatch(
        coreActions.requestMarkTutotialStepsComplite({ steps: [step] })
      )

      if (!opts?.silent) {
        const module = await import('web-components/TutorialNotification');
        const Comp = module.default;

        toast(Comp,
          {
            className: 'Toastify__toast--with-custom-component',
            autoClose: 7000,
            position: 'top-right',
            toastId: `tutorial-complete-${step}`,
          },
        )
      }

      return { ok: true, result }
    } catch (err) {
      toast(`Failed to mark tutorial "${step}" complete`, { position: 'top-right', autoClose: 5000 })

      console.error('mark tutorial failed', err)
      return { ok: false, error: err }
    } finally {
      inFlightRef.current[step] = false
    }
  }, [dispatch, completedSteps])

  return { completeTutorialStep }
}
